import React from 'react';
import PropTypes from 'prop-types';
import { PAGE_COMMANDS } from '../navigator/navigatorPortalNames';
import RenderToPortal from '../../../components/portals/RenderToPortal';

/**
 * A portaled container for all the controls in the page header area, for example "+ Create New XXX"
 * Register a portal with the PAGE_COMMANDS constant wherever you want the commands to show up.
 */

const propTypes = {
  children: PropTypes.element
};

const defaultProps = {};

export default function PageCommands(props) {
  const {children} = props;
  return (
    <RenderToPortal id={PAGE_COMMANDS}>
      <div className="d-flex flex-row align-items-center floating-commands">
        {children}
      </div>
    </RenderToPortal>
  );
}

PageCommands.propTypes = propTypes;
PageCommands.defaultProps = defaultProps;